<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="on_delete" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="alias_account_id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.alias_account_id.displayControl.styles.style"
          [ngClass]="row.cells.alias_account_id.displayControl.styles.classes"
          [matTooltip]="row.cells.alias_account_id.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.alias_account_id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.alias_account_id.editControl.styles.style"
          [ngClass]="row.cells.alias_account_id.editControl.styles.classes"
          [matTooltip]="row.cells.alias_account_id.editControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.alias_account_id.editControl.text }}</div>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_alias_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_alias_name.displayControl.styles.style"
          [ngClass]="row.cells.material_alias_name.displayControl.styles.classes"
          [matTooltip]="row.cells.material_alias_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_alias_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['material_alias_name_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.material_alias_name.editControl.readOnly || row.cells.material_alias_name.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.material_alias_name.editControl.placeholder}}"
            [ngStyle]="row.cells.material_alias_name.editControl.styles.style"
            [ngClass]="row.cells.material_alias_name.editControl.styles.classes"
            [matTooltip]="row.cells.material_alias_name.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_alias_description">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_alias_description.displayControl.styles.style"
          [ngClass]="row.cells.material_alias_description.displayControl.styles.classes"
          [matTooltip]="row.cells.material_alias_description.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_alias_description.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['material_alias_description_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.material_alias_description.editControl.readOnly || row.cells.material_alias_description.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.material_alias_description.editControl.placeholder}}"
            [ngStyle]="row.cells.material_alias_description.editControl.styles.style"
            [ngClass]="row.cells.material_alias_description.editControl.styles.classes"
            [matTooltip]="row.cells.material_alias_description.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="sales_order_discount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.sales_order_discount.displayControl.styles.style"
          [ngClass]="row.cells.sales_order_discount.displayControl.styles.classes"
          [matTooltip]="row.cells.sales_order_discount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.sales_order_discount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['sales_order_discount_edit']"
            matInput
            numberBox
            [format]="row.cells.sales_order_discount.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.sales_order_discount.editControl.readOnly || row.cells.sales_order_discount.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.sales_order_discount.editControl.placeholder}}"
            [ngStyle]="row.cells.sales_order_discount.editControl.styles.style"
            [ngClass]="row.cells.sales_order_discount.editControl.styles.classes"
            [matTooltip]="row.cells.sales_order_discount.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
